import {Component, ErrorInfo, ReactNode} from 'react';

import {logger, portalMutationTracer} from 'utils';

type Props = {
    fallback: ReactNode;
    children: ReactNode;
};

type State = {
    failed: boolean;
};

// An error that escapes React's commit phase tears down the whole root: the page keeps the DOM it last painted
// and silently stops responding to anything, which is indistinguishable from a hang and only a reload clears.
// A boundary keeps such a failure inside its own subtree so the rest of the app stays interactive.
export class ErrorBoundary extends Component<Props, State> {
    state: State = {failed: false};

    static getDerivedStateFromError(): State {
        return {failed: true};
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        logger.error(error, {componentStack: errorInfo.componentStack});
        portalMutationTracer.dump(error.message);
    }

    render() {
        const {failed} = this.state;
        const {fallback, children} = this.props;

        return failed ? fallback : children;
    }
}
